import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authService.isLoggedIn()) {
      // If user is logged in and tries to access login page, redirect to home
      if (state.url.includes('/login')) {
        this.router.navigate(['/']);
        return false;
      }
      return true;
    } else {
      // If not logged in and trying to access protected routes, redirect to login
      if (!state.url.includes('/login')) {
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    }
  }
}